/**
 * `+447476555946` → `07476 555946`.
 *
 * The domestic form, because that is how an owner has the number written on the
 * van and saved in their phone. Anything that is not a UK mobile in E.164 is
 * passed through untouched rather than mangled.
 *
 * Note this is deliberately NOT the format used on the receptionist settings
 * screen (`+44 7476 555946`), which shows the international form beside the
 * Twilio plumbing. This one is for prose read by the customer.
 */
export function formatUkNumber(e164: string): string {
  const m = e164.match(/^\+44(\d{4})(\d{6})$/);
  return m ? `0${m[1]} ${m[2]}` : e164;
}
